// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__baCSF","overlayInner":"Modal_overlayInner__3MZgY","close":"Modal_close__RYdb0","innerBox":"Modal_innerBox__fYq9D","description":"Modal_description__0XP48"};